import { get, create } from './common';

export default {
    getMarketingQuestions: async (params, token) => get(`/v1/Settings/GetMarketingQuestions?isActive=${params.isActive}`, token),
    saveMarketingQuestionResponse: async (params, token) => create(`/v1/Settings/saveMarketingQuestionResponse`, params, token),
    getStockNumberUsed: async (params, token) => get(`/v1/Package/IsStockNumberUsed`, token),
}